
import LeadForm from './LeadForm';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-blue-50/50 via-white to-emerald-50/50 pt-20 sm:pt-24">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-emerald-500/5"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-32 w-full relative z-10">
        <div className="grid lg:grid-cols-5 gap-8 sm:gap-12 items-center">
          <div className="lg:col-span-3 space-y-6 sm:space-y-8">
            <div className="space-y-4">
              <h1 className="text-3xl sm:text-5xl lg:text-7xl font-bold text-gray-900 leading-tight">
                Transform Your <br />
                <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                  Instagram Lead Generation
                </span>
              </h1>
              <p className="text-sm sm:text-xl text-gray-600 max-w-2xl leading-relaxed">
                We build, post, and create ad campaigns for landscaping companies. Guaranteed to cut your lead generation costs and deliver results. <strong className="text-emerald-700">Currently generating leads for under $5 each on average.</strong>
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row flex-wrap gap-4">
              <LeadForm />
              <a href="#about" className="bg-transparent text-gray-700 px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base font-semibold hover:bg-gray-100 transition-all duration-300 border-2 border-gray-300 whitespace-nowrap cursor-pointer text-center">
                Learn More
              </a>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8 pt-4">
              <div>
                <div className="text-2xl sm:text-4xl font-bold text-gray-900">&lt;$5</div>
                <div className="text-xs sm:text-sm text-gray-600">Per Lead Average</div>
              </div>
              <div className="hidden sm:block w-px h-12 bg-gray-300"></div>
              <div>
                <div className="text-2xl sm:text-4xl font-bold text-gray-900">$500K+</div>
                <div className="text-xs sm:text-sm text-gray-600">Saved for Clients</div>
              </div>
              <div className="hidden sm:block w-px h-12 bg-gray-300"></div>
              <div>
                <div className="text-2xl sm:text-4xl font-bold text-gray-900">80%</div>
                <div className="text-xs sm:text-sm text-gray-600">Cost Reduction</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 relative mt-8 lg:mt-0">
            <div className="relative transform hover:rotate-0 transition-transform duration-500">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400 to-blue-500 rounded-3xl blur-3xl opacity-20"></div>
              <div className="relative bg-white rounded-2xl sm:rounded-3xl shadow-2xl p-4 sm:p-6 border border-gray-200">
                <img 
                  src="https://public.readdy.ai/ai/img_res/41bbc9f7e9ac18313d49ae74c48ac9a9.jpg" 
                  alt="Instagram Feed Mockup"
                  className="w-full h-auto rounded-xl sm:rounded-2xl object-cover object-top"
                />
                <div className="absolute -bottom-3 -right-3 sm:-bottom-4 sm:-right-4 bg-emerald-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg">
                  <div className="text-xs sm:text-sm font-semibold whitespace-nowrap">✓ Guaranteed Results</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
